import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoInstagram = function LogoInstagram(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.instagram"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "logo-instagram"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M21.6 2.09998H10.4C5.79997 2.09998 2.09998 5.79997 2.09998 10.4V21.6C2.09998 26.2 5.79997 29.9 10.4 29.9H21.6C26.2 29.9 29.9 26.2 29.9 21.6V10.4C29.9 5.79997 26.2 2.09998 21.6 2.09998ZM27.1 21.6C27.1 24.6 24.7 27.1 21.6 27.1H10.4C7.39997 27.1 4.89998 24.7 4.89998 21.6V10.4C4.89998 7.39997 7.29997 4.89998 10.4 4.89998H21.6C24.6 4.89998 27.1 7.29997 27.1 10.4V21.6Z",
    fill: "url(#paint0_linear_4223_6534)"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_2",
    d: "M16 8.80005C12 8.80005 8.79999 12 8.79999 16C8.79999 20 12 23.2 16 23.2C20 23.2 23.2 20 23.2 16C23.2 12 20 8.80005 16 8.80005ZM16 20.4C13.6 20.4 11.6 18.4 11.6 16C11.6 13.6 13.6 11.6 16 11.6C18.4 11.6 20.4 13.6 20.4 16C20.4 18.4 18.4 20.4 16 20.4Z",
    fill: "url(#paint1_linear_4223_6534)"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_3",
    d: "M23.2 10.6C24.1389 10.6 24.9 9.8389 24.9 8.90001C24.9 7.96113 24.1389 7.20001 23.2 7.20001C22.2611 7.20001 21.5 7.96113 21.5 8.90001C21.5 9.8389 22.2611 10.6 23.2 10.6Z",
    fill: "url(#paint2_linear_4223_6534)"
  }))), /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint0_linear_4223_6534",
    x1: 16,
    y1: 29.7825,
    x2: 16,
    y2: 2.35218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint1_linear_4223_6534",
    x1: 16,
    y1: 29.7826,
    x2: 16,
    y2: 2.35225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React__default.createElement("linearGradient", {
    id: "paint2_linear_4223_6534",
    x1: 23.1849,
    y1: 29.7825,
    x2: 23.1849,
    y2: 2.35221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React__default.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React__default.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  }))));
};

export { LogoInstagram };
